//src/admin/album.js//
import React, { useState, useEffect } from 'react';
import { TextField, Button, Typography, Table, TableBody, TableCell, TableHead, TableRow, Paper,IconButton, Checkbox  } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import axios from 'axios';
import BASE_URL from '../config';
import {footerConfigs} from '../components/footerConfigs';

const Album = () => {
  const school = footerConfigs.bheema;
  const [albumName, setAlbumName] = useState('');
  const [albums, setAlbums] = useState([]);
  const [error, setError] = useState('');
  const [editId, setEditId] = useState(null);
  const [images, setImages] = useState([]);
  const [selectedAlbumId, setSelectedAlbumId] = useState(null);
  const [selectedImages, setSelectedImages] = useState([]);
  const [successMessage, setSuccessMessage] = useState('');
  
  const fetchAlbums = async () => {
    const response = await axios.get(`${BASE_URL}/api/albums`);
    setAlbums(response.data);
  };

  const fetchImages = async (albumId) => {
    const response = await axios.get(`${BASE_URL}/api/albums/${albumId}/images`);
    setImages(response.data);
    setSelectedAlbumId(albumId);
  };
  const handleSelectImage = (imageName) => {
    if (selectedImages.includes(imageName)) {
      setSelectedImages(selectedImages.filter((name) => name !== imageName));
    } else {
      setSelectedImages([...selectedImages, imageName]);
    }
  };
  /* const handleDeleteImage = async (imageName) => {
    try {
      await axios.delete(`http://localhost:6100/api/albums/${selectedAlbumId}/image`, {
        data: { imageName },
      });
      fetchImages(selectedAlbumId);
    } catch (error) {
      setError('Failed to delete image');
    }
  }; */


  const handleDeleteSelectedImages = async () => {
    if (selectedImages.length === 0) {
      setError('No images selected');
      return;
    }

    try {
      await axios.delete(`${BASE_URL}/api/albums/${selectedAlbumId}/images`, {
        data: { imageNames: selectedImages },
      });
      setSuccessMessage('Selected images deleted successfully');
      setError('');
      setSelectedImages([]);
      fetchImages(selectedAlbumId);
    } catch (error) {
      setError('Failed to delete selected images');
    }
  };

  useEffect(() => {
    fetchAlbums();
  }, []);

  const handleAddAlbum = async () => {
    if (!albumName) return;

    try {
      const checkResponse = await axios.get(`${BASE_URL}/api/albums/check/${albumName}`);
      if (checkResponse.data.exists) {
        setError('Album already exists');
        return;
      }
      if (editId) {
        // Update existing album
        await axios.put(`${BASE_URL}/api/albums/update/${editId}`, { album_name: albumName });
        setEditId(null);
      } else {
        // Add new album
        await axios.post(`${BASE_URL}/api/albums/add`, { album_name: albumName });
      }
      //await axios.post('http://localhost:6100/api/albums/add', { album_name: albumName });
      setError('');
      setAlbumName('');
      fetchAlbums();
    } catch (err) {
      setError('Failed to add album');
    }
  };

  const handleDeleteAlbum = async (id) => {
    await axios.delete(`${BASE_URL}/api/albums/${id}`);
    fetchAlbums();
  };
  const handleEditAlbum = (album) => {
    setAlbumName(album.album_name);
    setEditId(album.album_id);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };
  const handleShareOnWhatsApp = (album) => {
    //const message = `Check out this newly added album: ${album.album_name}\nhttps://www.smcjainschoolshp.org/photo-gallery/${album.album_id}`;
    const message = `Check out this newly added album: ${album.album_name}\n${school.domain}/photo-gallery/${album.album_id}`;
    /* const whatsappUrl = `https://wa.me/?text=${encodeURIComponent(message)}`;
    window.open(whatsappUrl, '_blank'); */
    const isMobile = /iPhone|iPad|iPod|Android|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);

  const whatsappURL = isMobile
    ? `whatsapp://send?text=${encodeURIComponent(message)}`
    : `https://web.whatsapp.com/send?text=${encodeURIComponent(message)}`;

  window.open(whatsappURL, "_blank");
  };
  return (
    <div style={{ padding: '20px' }}>
      <Typography variant="h4" gutterBottom>Manage Albums</Typography>

      <TextField
        label="Album Name"
        value={albumName}
        onChange={(e) => setAlbumName(e.target.value)}
        fullWidth
        margin="normal"
      />

<Button variant="contained" color="primary" onClick={() => fetchImages(editId)}>View Images</Button>
{error && <Typography color="error">{error}</Typography>}
{successMessage && <Typography color="success">{successMessage}</Typography>}
      {selectedAlbumId && (
        <Paper sx={{ mt: 4 }}>
          <Typography variant="h6">Images in Album</Typography>
          <Table>
            <TableHead>
              <TableRow>
              <TableCell>Select</TableCell>
                <TableCell>Image</TableCell>
                {/* <TableCell>Actions</TableCell> */}
              </TableRow>
            </TableHead>
            <TableBody>
              {images.map((image) => (
                <TableRow key={image.imageName}>
                   <TableCell>
                    <Checkbox
                      checked={selectedImages.includes(image.imageName)}
                      onChange={() => handleSelectImage(image.imageName)}
                    />
                  </TableCell>
                  <TableCell>
                    <img
                      src={`${BASE_URL}/uploads/photo_gallery/${selectedAlbumId}/${image.imageName}`}
                      alt={image.imageName}
                      width="100"
                    />
                  </TableCell>
                  {/* <TableCell>
                    <IconButton color="error" onClick={() => handleSelectImage(image.imageName)}>
                      <DeleteIcon />
                    </IconButton>
                  </TableCell> */}
                </TableRow>
              ))}
            </TableBody>
          </Table>
          <Button variant="contained" color="error" onClick={handleDeleteSelectedImages}>
            Delete Selected Images
          </Button>
        </Paper>
      )}


      <Button variant="contained" color="primary" onClick={handleAddAlbum}>Add Album</Button>
      {error && <Typography color="error">{error}</Typography>}

      <Paper sx={{ mt: 4 }}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Album ID</TableCell>
              <TableCell>Album Name</TableCell>
              <TableCell>Actions</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {albums.map((album) => (
              <TableRow key={album.album_id}>
                <TableCell>{album.album_id}</TableCell>
                <TableCell>{album.album_name}</TableCell>
                <TableCell>
                {/* <Button color="primary" onClick={() => handleEditAlbum(album)}>Edit</Button>
                  <Button color="error" onClick={() => handleDeleteAlbum(album.album_id)}>Delete</Button> */}
                  <IconButton color="primary" onClick={() => handleEditAlbum(album)}>
                    <EditIcon />
                  </IconButton>
                  <IconButton color="error" onClick={() => handleDeleteAlbum(album.album_id)}>
                    <DeleteIcon />
                  </IconButton>
                  <IconButton color="success" onClick={() => handleShareOnWhatsApp(album)}>
                    <WhatsAppIcon />
                  </IconButton>

                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </Paper>
    </div>
  );
};

export default Album;
